// The account's display units, for every surface that renders a measurement.
//
// This is the ONE null-coalescing point for the account unit settings:
// GET /v1/me returns `unitSettings: UnitSettings | null` (null until the
// account picks its own), and an older cloud omits the field entirely. Both
// land on DEFAULT_UNIT_SETTINGS here, so consumers always get a complete
// seven-category object and never touch the null themselves.

import { DEFAULT_UNIT_SETTINGS, type UnitSettings } from '@neomaris/protocol';

import { useAuth } from '../auth';

export function useUnits(): UnitSettings {
  return useAuth().user?.unitSettings ?? DEFAULT_UNIT_SETTINGS;
}
